export default {
    _colors_tween_out: 'colors-tween-out',
    _same_shape_2: 'same-shape-2',
    _sprinkle_fall: 'sprinkle-fall',
    _appear: '&-appear',
    _same_shape_color2: 'same-shape-color2',
    _play_button_pop_up: 'play-button-pop-up',
    _pick_sprinkle_color: 'pick-sprinkle-color',
    _donuts_enter_leave: 'donuts-enter-leave',
    _different_color2: 'different-color2',
    _pick_frosting_color: 'pick-frosting-color',
    _make_another_donut: 'make-another-donut',
    _title_donut_leave: 'title-donut-leave',
    _different_shape_color1: 'different-shape-color1',
    _correct_answer: 'correct-answer',
    _different_shape1: 'different-shape1',
    _different_shape2: 'different-shape2',
    _click_select_donuts: 'click-select-donuts',
    _same_shape_color1: 'same-shape-color1',
    _play_again: 'play-again',
    _click_eat_up: 'click-eat-up',
    _incorrect_answer: 'incorrect_answer',
    _great_job: 'great-job',
    _pick_sprinkle_shape: 'pick-sprinkle-shape',
    _colors_tween_in: 'colors-tween-in',
    _donut_yummy_eat_up: 'donut-yummy-eat-up',
    _different_color1: 'different-color1',
    _eat_donut: 'eat-donut',
    _same_color2: 'same-color2',
    _same_color1: 'same-color1',
    _different_letters_rise: 'different-letters-rise',
    _different_shape_color2: 'different-shape-color2',
    _hungry_make_donut: 'hungry-make-donut',
    _same_shape_1: 'same-shape-1',
    _yum: 'yum',
    _same_letters_fall: 'same-letters-fall',
    _jingle_same_different: 'jingle-same-different',
    _choose_donut_shape: 'choose-donut-shape',
    _same_different: 'same-different',
    _title_donut_enter: 'title-donut-enter',
}